import { useEffect, useEffectEvent } from 'react'
import { useSelector } from '@/libs/state'
import { listTopics } from '../application/list-topics'
import { topics$ } from '../store'
import { chat as chatPort, notify } from '../wiring'

const POLL_MS = 5000

// The conversation list. Polls on an interval as the realtime seam: replacing
// this body with a PocketBase SSE subscription later changes nothing for callers
// or the UI. The interval is the only external sync here, so the effect is
// justified (and uses useEffectEvent so reload never re-arms the timer).
const useConversations = () => {
	const topics = useSelector(topics$)

	const reload = useEffectEvent(async () => {
		topics$.set(await listTopics(chatPort, notify))
	})

	useEffect(() => {
		reload()
		const timer = setInterval(reload, POLL_MS)
		return () => clearInterval(timer)
	}, [])

	return { topics, reload }
}

export { useConversations }
